import React, { Component } from 'react'
import { findDOMNode } from 'react-dom'
import { BrowserRouter, Route } from 'react-router-dom'
import za from 'za-helper'
import { configClient } from 'za-react'
import zhihuHybrid from 'zhihu-hybrid'
import Activity from './Activity'
import Home from './Home'
import Campaign from './Campaign'
import styles from './App.css'

function onBeforeSend(zaLogEntry) {
  const isHybrid = /ZhihuHybrid/.test(window.navigator.userAgent)
  if (!isHybrid) return true
  if (zaLogEntry.log_type === 7) {
    return true
  }
  zhihuHybrid.ready().then(() => {
    zhihuHybrid.dispatch('base/trackZA', { log: zaLogEntry.toBase64() })
  })
  return false
}

za
  .init({
    sdkVersion: '2.26.0',
    onBeforeSend,
    shouldAutoTrackPageShow: false, // 自动记录 trackPageShow()
    shouldAutoTrackOpenUrl: true, // 为 <a> 自动添加 OpenUrl 事件
    shouldAutoTrackPageMonitor: false, // 自动记载页面性能的 trackMonitor()
    normalizeElement: element =>
      element instanceof Component ? findDOMNode(element) : element, // eslint-disable-line react/no-find-dom-node
  })
  .then(() => {
    const v3Config = { onBeforeSend }
    const zaClient = new window.zap.Client(v3Config, {
      experimentalProto3: true,
    })
    configClient(zaClient)
  })

const App = () => (
  <BrowserRouter>
    <div className={styles.app}>
      <Route path="/" component={Home} exact />
      <Route path="/home" component={Home} exact />
      <Route path="/activity/:activityId" component={Activity} exact />
      <Route path="/campaign" component={Campaign} />
    </div>
  </BrowserRouter>
)

export default App



// WEBPACK FOOTER //
// ./src/pages/App.js